import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { ReactComponent as ViewDetailsSvg } from '@assets/svg/executive-summary/ic-view-details.svg';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  title: string;
  link: string;
  linkText?: string;
  rightElement?: React.ReactElement;
  children: React.ReactElement;
}

const StatisticWrapper: React.FC<IProps> = ({ title, children, link, linkText, rightElement }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  return (
    <div className={style.statisticWrapper}>
      <div className={style.statisticHead}>
        <span className={style.statisticHeadText}>{title}</span>
        {rightElement}
      </div>
      <div className={style.statisticBody}>{children}</div>
      <div className={style.statisticFooter}>
        <Link className={style.link} to={link} state={{ prevPage: pathname }}>
          <span>{t(linkText || 'View Details')}</span>
          <ViewDetailsSvg />
        </Link>
      </div>
    </div>
  );
};

export default StatisticWrapper;
